import React, { useEffect } from 'react';
import { useHistory, NavLink } from 'react-router-dom';
import ReactGA from 'react-ga';
import { ReactGAEvents } from '../../utils/Constants';

const FourZeroFourLayout = () => {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.set({ page: history.location.pathname });
        ReactGA.pageview(history.location.pathname);
    }, [history.location.pathname]);

    return (
        <div>
            <div className="flex flex-col items-start justify-start md:justify-center md:items-center md:flex-row md:space-x-6 md:mt-24">
                <div className="pt-6 pb-8 space-x-2 md:space-y-5">
                    <h1 className="text-6xl font-extrabold font-mono leading-9 tracking-tight text-red-500 md:text-8xl md:leading-14 md:border-r-2 md:border-neutral-800 md:px-6">
                        404
                    </h1>
                </div>
                <div className="max-w-md">
                    <p className="mb-4 text-xl font-bold font-mono leading-normal md:text-2xl text-neutral-300">
                        Page not found.
                    </p>
                    <p className="mb-8 text-neutral-500 font-mono text-sm">No worries, head back home.</p>
                    <NavLink
                        to="/"
                        className="hover:no-underline"
                        onClick={() => {
                            ReactGA.event({
                                category: ReactGAEvents.InternalLink,
                                action  : 'Clicked Internal Link /',
                            });
                        }}
                    >
                        <button
                            type="button"
                            className="inline px-4 py-2 text-sm font-mono font-medium leading-5 text-white transition-colors duration-200 bg-red-600 border border-transparent rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-red-500 hover:bg-red-700"
                        >
                            cd ~
                        </button>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default FourZeroFourLayout;
